import { Button } from '@workingclock/ui';
import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AppStoreButton } from '../common/app-store-button';
import { GooglePlayButton } from '../common/google-play-button';
import { AccentBar } from '../layout/accent-bar';
import { Container } from '../layout/container';

import { BrowserFrame, DesktopFrame, MiniEntryList, MiniTimer, PhoneFrame } from './device-frames';

export function CrossPlatformSection() {
  const { t } = useTranslation('marketing');

  return (
    <section className="border-b border-border bg-surface py-16 md:py-24">
      <Container>
        <div className="max-w-2xl">
          <AccentBar className="mb-5" />
          <h2 className="text-display text-ink">{t('home.crossPlatform.heading')}</h2>
          <p className="mt-4 text-body text-muted">{t('home.crossPlatform.body')}</p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button variant="secondary" asChild>
              <Link to="/download">
                <Download aria-hidden />
                {t('home.crossPlatform.downloadDesktop')}
              </Link>
            </Button>
            <AppStoreButton />
            <GooglePlayButton />
          </div>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          <BrowserFrame>
            <p className="mb-3 text-label text-muted">{t('home.crossPlatform.web')}</p>
            <MiniTimer project={t('home.crossPlatform.demoProject')} time={t('home.crossPlatform.demoTime')} active />
          </BrowserFrame>

          <PhoneFrame>
            <p className="mb-3 text-label text-muted">{t('home.crossPlatform.mobile')}</p>
            <MiniTimer project={t('home.crossPlatform.demoProject')} time={t('home.crossPlatform.demoTime')} active />
          </PhoneFrame>

          <DesktopFrame>
            <p className="mb-3 text-label text-muted">
              <Link to="/download" className="underline-offset-4 hover:text-ink hover:underline">
                {t('home.crossPlatform.desktop')}
              </Link>
            </p>
            <MiniEntryList
              entries={[
                { label: t('home.crossPlatform.entries.onboardingCall'), duration: '00:42:11' },
                { label: t('home.crossPlatform.entries.followUpNotes'), duration: '00:11:03' },
                { label: t('home.crossPlatform.entries.invoiceDraft'), duration: '00:26:40' },
              ]}
            />
          </DesktopFrame>
        </div>
      </Container>
    </section>
  );
}
